import React from 'react';
import './style.scss';
function outlinedButton({ children, onClick, ...rest }) {
	return (
		<button onClick={onClick} className="outline-button" {...rest}>
			{children}
		</button>
	);
}
export default outlinedButton;
